import { request } from "./request";

export default {
  /**
   * 更新付款时间表摘要
   * @param {Number} ContractId 合同Id
   */
  changePaymentScheduleSummary(ContractId) {
    return request({
      url: "/Payment/changePaymentScheduleSummary",
      method: "post",
      params: {
        ContractId,
      },
    });
  },
  /**
   * 获取付款时间表摘要
   * @param {Number} PaymentSummaryId 摘要Id
   */
  getPaymentScheduleSummary(PaymentSummaryId, ContractId) {
    return request({
      url: "/Payment/getPaymentScheduleSummary",
      method: "get",
      params: {
        PaymentSummaryId,
        ContractId,
      },
    });
  },
  /**
   * 获取付款摘要Id
   * @param {Number} ContractId 合同Id
   */
  getPaymentSummaryIdByContractId(ContractId) {
    return request({
      url: "/Payment/getPaymentSummaryIdByContractId",
      method: "get",
      params: {
        ContractId,
      },
    });
  },
  /**
   * 获取付款时间计划
   * @param {Number} PaymentId
   * @returns
   */
  getPaymentScheduleList(PaymentSummaryId) {
    return request({
      url: "/Payment/getPaymentScheduleList",
      method: "get",
      params: {
        PaymentSummaryId,
      },
    });
  },
  /**
   * 获取付款时间明细
   * @param {Number} PaymentId
   * @returns
   */
  getPaymentScheduleDetails(PaymentId) {
    return request({
      url: "/Payment/getPaymentScheduleDetails",
      method: "get",
      params: {
        PaymentId,
      },
    });
  },
  /**
   * 获取付款时间
   * @param {Number} PaymentId
   * @returns
   */
  getPaymentSchedule(Id, PaymentSummaryId, Action) {
    return request({
      url: "/Payment/getPaymentSchedule",
      method: "get",
      params: {
        Id,
        PaymentSummaryId,
        Action,
      },
    });
  },
  /**
   * 重置/计算PaymentSchedule
   * @param {Object} PaymentSchedule
   * @returns
   */
  regeneratePayment(PaymentSchedule) {
    return request({
      url: "/Payment/regeneratePayment",
      method: "post",
      data: PaymentSchedule,
    });
  },
  /**
   * 保存Payment Schedule
   * @param {Object} PaymentSchedule
   * @returns
   */
  savePaymentSchedule(PaymentSchedule) {
    return request({
      url: "/Payment/savePaymentSchedule",
      method: "post",
      data: PaymentSchedule,
    });
  },
  /**
   * 删除付款时间
   * @param {Number} PaymentId
   * @returns
   */
  deletePaymentSchedule(PaymentId) {
    return request({
      url: "/Payment/deletePaymentSchedule",
      method: "delete",
      params: {
        PaymentId,
      },
    });
  },
  /**
   * 预设付款时间
   * @param {NUmber} PaymentSummaryId 付款摘要Id
   * @returns
   */
  presetPaySetting(PaymentSummaryId, ContractAction) {
    return request({
      url: "/Payment/presetPaySetting",
      method: "get",
      params: {
        PaymentSummaryId,
        ContractAction,
      },
    });
  },
  /**
   * 更新付款状态
   * @param {NUmber} PaymentDetailId
   * @param {String} PaymentStatus
   * @returns
   */
  changePaymentStatus(PaymentScheduleDetail) {
    return request({
      url: "/Payment/changePaymentStatus",
      method: "post",
      data: PaymentScheduleDetail,
    });
  },
};
